import { render, staticRenderFns } from "./MentorSchedule.vue?vue&type=template&id=6005d328&scoped=true"
import script from "./MentorSchedule.vue?vue&type=script&lang=js"
export * from "./MentorSchedule.vue?vue&type=script&lang=js"
import style0 from "./MentorSchedule.vue?vue&type=style&index=0&id=6005d328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6005d328",
  null
  
)

export default component.exports